import { factory } from '@wix/web-bi-logger';

const BI_PROJECT_NAME = 'secrets-manager';
const BI_PROJECT_SRC = 105;

export const createLogger = ({ msid, uuid }) => {
  return factory({ endpoint: BI_PROJECT_NAME })
    .updateDefaults({
      src: BI_PROJECT_SRC,
      msid,
      uuid,
    })
    .logger();
};
